import React from 'react';
import './LoginPage.css';
import { login, clearError } from '../../redux/authentication/authentication_actions';
import { connect } from 'react-redux';
import logoImage from '../../assets/images/2e-building.png';

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
    };
  }

  onLoginSubmit() {
    const { username, password } = this.state;
    if (!username || !password) return;
    this.props.login(username, password);
  }

  onValueChange(event, fieldName) {
    this.setState({ ...this.state, [fieldName]: event.target.value });
  }

  componentDidUpdate(prevProps) {
    if (!this.props.isLoggingIn && this.props.isLoggingIn !== prevProps.isLoggingIn && !this.props.errorMessage) {
      this.props.history.push('/');
    }
  }

  register() {
    this.props.history.push('/register');
  }

  componentDidMount() {
    this.props.clearError();
  }

  render() {
    const { isLoggingIn, errorMessage } = this.props;
    return (
      <div className="zenlogin scrollable-container">
        <div className="login-container">
          <div className="login-header">
            <img style={{ width: '100%' }} src={logoImage} />
            <a style={{ fontSize: 20, paddingTop: 10 }} href="#">Building Energy Code</a>
          </div>

          <div className="login-content">
            <form
              className="user-login-form"
              onSubmit={() => this.onLoginSubmit()}
            >
              { this.props.location.search.includes("activated=0") ? (
                <div className="alert alert-danger" id="cannot-activated-notification" >Account cannot be activated.</div>
              ) : null}

              { this.props.location.search.includes("activated=1") ? (
                <div className="alert alert-success" id="activated-notification" >Account is activated.</div>
              ) : null}

              <div className="form-item js-form-item form-type-textfield js-form-type-textfield form-item-name js-form-item-name form-group">
                <label
                  htmlFor="login-name"
                  className="control-label js-form-required form-required"
                >
                  Email
                </label>
                <input
                  autoCorrect="none"
                  autoCapitalize="none"
                  spellCheck="false"
                  className="form-text required form-control"
                  id="login-username"
                  name="username"
                  value={this.state.username}
                  size="60"
                  maxLength="60"
                  type="text"
                  onChange={event => this.onValueChange(event, 'username')}
                  disabled={isLoggingIn}
                  required
                />
              </div>
              <div className="form-item js-form-item form-type-password js-form-type-password form-item-password js-form-item-password form-group">
                <label
                  htmlFor="login-password"
                  className="control-label js-form-required form-required"
                >
                  Password
                </label>
                <input
                  className="form-text required form-control"
                  id="login-password"
                  name="pass"
                  size="60"
                  maxLength="128"
                  type="password"
                  value={this.state.password}
                  onChange={event => this.onValueChange(event, 'password')}
                  disabled={isLoggingIn}
                  required
                />
              </div>
              {errorMessage ? (
                <div className="alert alert-danger" id="login-error-msg-box" >{errorMessage}</div>
              ) : null}
              <div
                className="form-actions form-group js-form-wrapper form-wrapper"
              >
                <button
                  onClick={this.onLoginSubmit.bind(this)}
                  type="submit"
                  className="button js-form-button form-button btn-primary btn icon-before"
                  id="login-button"
                  disabled={isLoggingIn}
                >
                  <span
                    className="icon glyphicon glyphicon-log-in"
                    aria-hidden="true"
                  />
                  {isLoggingIn ? 'Logging In...' : 'Log In'}
                </button>
                <button
                  onClick={this.register.bind(this)}
                  type="button"
                  className="button btn icon-before"
                >
                  <span
                    className="icon glyphicon glyphicon-user"
                    aria-hidden="true"
                  />
                  Register
                </button>
                <div className="free-space" />
                <a onClick={() => this.props.history.push('/request_reset_password')} href="#">Reset Password</a>
              </div>
            </form>
          </div>

          <div className="login-footer" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  errorMessage: state.authentication.errorMessage,
  isLoggingIn: state.authentication.loggingIn,
});

const mapDispatchToProps = dispatch => ({
  login: (...args) => dispatch(login(...args)),
  clearError: (...args) => dispatch(clearError(...args)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoginPage);



// WEBPACK FOOTER //
// ./src/pages/login/LoginPage.js